import { useEffect, useState } from "react";
import {
  EnumMenuType,
  EnumTempBranchRequestStatus,
  TempBranchPendingRequestModel,
} from "../Managers/dataStructures";
import {
  fetchTeamLeadPendingRequests,
  sendTeamLeadApprovalRequest,
} from "../Managers/wepApiManager";
import {
  getLanguage,
  getTempBranchStatusElement,
  pageIsSearchable,
} from "../Managers/dataProvider";
import { ActivityIndicator } from "../Managers/utilityComponents";
import { filterPendingRequestData } from "../Managers/utilityFunctions";
import { getCurrentUser } from "../Managers/profileManager";

interface TLWorkstationProps {
  searchString: string;
}

export default function TLWorkstation(props: TLWorkstationProps) {
  const isEnglish = getLanguage();
  const [isActivityIndicator, setIsActivityIndicator] =
    useState<boolean>(false);
  const [pendingRequests, setPendingReuests] = useState<
    TempBranchPendingRequestModel[]
  >([]);
  let [isProcessingRequest, setIsProcessRequest] = useState<number>(0);

  useEffect(() => {
    setIsActivityIndicator(true);
    fetchTeamLeadPendingRequests(
      getCurrentUser().user_id,
      (array_requests: TempBranchPendingRequestModel[]) => {
        setIsActivityIndicator(false);
        setPendingReuests(array_requests);
      }
    );
  }, []);

  const searchString: string = pageIsSearchable(
    EnumMenuType.TEAM_LEAD_WORKSTATION
  )
    ? props.searchString
    : "";

  async function handlerRequest(
    request: TempBranchPendingRequestModel,
    isAccepted: boolean
  ) {
    console.log(" accepted=" + isAccepted);
    // const request_status: EnumTempBranchRequestStatus = isAccepted
    //   ? EnumTempBranchRequestStatus.ACCEPTED
    //   : EnumTempBranchRequestStatus.REJECTED;
    const item_index: number = pendingRequests.findIndex(
      (x) => x.user.email_id === request.user.email_id
    );
    let pd_array: TempBranchPendingRequestModel[] = pendingRequests;
    pd_array[item_index].activity_indicator = true;
    isProcessingRequest++;
    setIsProcessRequest(isProcessingRequest);

    //const isSuccess: boolean = await branchChangeRequestForTeamLead();
    sendTeamLeadApprovalRequest(
      getCurrentUser().user_id,
      request.user.user_id,
      (isSuccess: boolean, message: string) => {
        if (isSuccess) {
          pd_array[item_index].request_status = getTempBranchStatusElement(
            EnumTempBranchRequestStatus.ACCEPTED
          );
          pd_array[item_index].activity_indicator = false;
          setPendingReuests(pd_array);
        } else {
          pd_array[item_index].request_status = getTempBranchStatusElement(
            EnumTempBranchRequestStatus.UNKNWON
          );
          pd_array[item_index].request_status.display_name = message;
          pd_array[item_index].activity_indicator = false;
          pd_array[item_index].message = message;
          setPendingReuests(pd_array);
        }
        isProcessingRequest--;
        setIsProcessRequest(isProcessingRequest);
      }
    );
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish ? "Pending Requests" : "Aussstehende Anfragen"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "A list of all Pending requests for the Team Lead to accept/reject for the current shift."
              : "Eine Liste aller ausstehenden Anfragen, die der Teamleiter für die aktuelle Schicht annehmen oder ablehnen kann."}
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          {/* <button
            //onClick={handleMassDownload}
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {isEnglish ? "Send Shift Report" : "Schichtbericht senden"}
          </button> */}
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="relative">
              {isActivityIndicator ? (
                <div className="min-w-full h-20 flex flex-row items-center justify-center">
                  {ActivityIndicator(1)}
                </div>
              ) : filterPendingRequestData(pendingRequests, searchString)
                  .length === 0 ? (
                <div className="flex mt-10 justify-center font-semibold">
                  {isEnglish
                    ? "No available pending requests."
                    : "Keine Ausstehenden Anfragen"}
                </div>
              ) : (
                <table className="min-w-full table-fixed divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900"
                      >
                        {isEnglish ? "Report Title" : "Berichtstiel"}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {isEnglish ? "User Name" : "Mitarbeiter Anmeldename"}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {isEnglish ? "Permanant Branch" : "Hauptarbeitsstätte"}
                      </th>
                      <th
                        scope="col"
                        className="relative py-3.5 pl-3 pr-4 sm:pr-3"
                      >
                        <span className="sr-only">
                          {isEnglish ? "Request Status" : "Request Status"}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {filterPendingRequestData(
                      pendingRequests,
                      searchString
                    ).map((x) => [CellRequests(x, handlerRequest)])}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CellRequests(
  request: TempBranchPendingRequestModel,
  handler: (request: TempBranchPendingRequestModel, isAccepted: boolean) => void
) {
  const isEnglish = getLanguage();
  function onRequestAccept() {
    handler(request, true);
  }

  return (
    <tr key={request.user.user_id}>
      <td className="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900">
        {request.user.first_name + " " + request.user.last_name}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {request.user.email_id}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {request.user.permanant_branch.name}
      </td>

      {request.activity_indicator === true ? (
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
          {ActivityIndicator(1)}
        </td>
      ) : request.request_status.status ===
        EnumTempBranchRequestStatus.PENDING ? (
        <td className="flex flex-row justify-items-center py-4">
          <div className="whitespace-nowrap pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
            <a
              onClick={onRequestAccept}
              href={"#" + request.user.user_id}
              className="text-indigo-600 hover:text-indigo-900"
            >
              {isEnglish ? "Accept" : "Akzeptieren"}
              <span className="sr-only">{", " + request.user.user_id}</span>
            </a>
          </div>
          {/* <div className="whitespace-nowrap pl-7 pr-4 text-right text-sm font-medium sm:pr-3">
            <a
              onClick={onRequestReject}
              href={"#" + request.user.user_id}
              className="text-indigo-600 hover:text-indigo-900"
            >
              Reject
              <span className="sr-only">{", " + request.user.user_id}</span>
            </a>
          </div> */}
        </td>
      ) : (
        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
          <span
            className={
              "inline-flex items-center rounded-md  px-2 py-1 text-xs font-medium  ring-1 ring-inset " +
              request.request_status.color_scheme
            }
          >
            {request.request_status.display_name}
          </span>
        </td>
      )}
    </tr>
  );
}
